import { safeDefine } from "@breuni-ui/safe-define";
import CubeRecoTracking from "../tracking/cube/CubeRecoTracking";
import GTMRecoTracking from "../tracking/GTM/GTMRecoTracking";
import AlgonomyTracking from "../tracking/algonomy/AlgonomyTracking";
import { recoCarouselContainerTagName } from "./recoCarouselContainerTagName";
import { textContentToJSON } from "../utils/textContentToJSON";
import { getRecoCarouselContainer } from "./getRecoCarouselContainer";

export type RecoCarouselContainerDependencies = {
  CubeRecoTracking: typeof CubeRecoTracking;
  GTMRecoTracking: typeof GTMRecoTracking;
  AlgonomyTracking: typeof AlgonomyTracking;
  textContentToJSON: typeof textContentToJSON;
  window: typeof window;
};

export type RecoCarouselContainer = ReturnType<
  typeof getRecoCarouselContainer
> &
  HTMLElement;

safeDefine(
  recoCarouselContainerTagName,
  getRecoCarouselContainer({
    CubeRecoTracking: CubeRecoTracking,
    GTMRecoTracking: GTMRecoTracking,
    AlgonomyTracking: AlgonomyTracking,
    textContentToJSON: textContentToJSON,
    window: window,
  }),
);
